(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$open = $('.js-open'),
		$close = $('.js-close'),
		$openComparison = $('.js-open-comparison'),
		$closeComparison = $('.js-close-comparison'),
		trialDownloadIDs = {
			pc: 'AVAST-ONE-FREE-WIN-PP',
			mac: 'AVAST-ONE-FREE-MAC-PP',
			android: 'AVAST-ONE-ANDROID-PP',
			ios: 'AVAST-ONE-IOS-PP'
		},
		detectedPlatform = avastGlobals.detect.os.name.toLowerCase(),
		$document = $(document),
		currentPageName = getCurrentPageName(),
		supportedPlatforms = {
			android: {
				text: 'Android',
				style: 'google-play.png'
			},
			ios: {
				text: 'iOS',
				style: 'app-store.png'
			},
			mac: {
				text: 'Mac',
				style: 'logo-mac'
			},
			pc: {
				text: 'Windows',
				style: 'logo-win'
			}
		},
		defaultIconName = 'google-play.png',
		configCurrentPage = {
			'supported-platform': getCurrentPlatform(),
			'product-id': trialDownloadIDs[getCurrentPlatform()]
		},
		pageSupportedPlatform = configCurrentPage['supported-platform'].toLowerCase();

	// fix platform name
	if (detectedPlatform === 'windows') {
		detectedPlatform = 'pc';
	}

	var cardToggler = new Vue({
	  el: '#card-toggler',
	  data: {
	    activeVal: 'individual'
	  },
	  methods: {
	    toggleActive: function(name) {
	      this.activeVal = name;
	    }
	  },
	  mounted: function() {
			if (avastGlobals.web.locale === 'en-us' || avastGlobals.web.locale === 'en-gb') {
				initModal(this.$el);
			}
	  },
	  updated: function() {
			if (avastGlobals.web.locale === 'en-us' || avastGlobals.web.locale === 'en-gb') {
				initModal(this.$el);
			}
	  },
	  delimiters: ['<%', '%>']
	});

	function initModal(element) {
		var modalButton = element.querySelector('[data-toggle="modal"]'),
			modalTarget = modalButton !== null ? modalButton.getAttribute('data-target') : null;

		if (modalButton !== null && modalTarget !== null) {
			modalButton.addEventListener('click', function() {
				loadModal(modalTarget);
			});

			modalButton.addEventListener('keypress', function(e) {
				if (e.charCode === 13) {
					loadModal(modalTarget);
				}
			});
		}
	}

	function loadModal(target) {
		// !!make sure name of source page for modal and target in modal trigger are same!!
		if (document.getElementById(target) === null) {
			var contentHolder = document.querySelector('.content-holder'),
				xhr = new XMLHttpRequest();

			xhr.onreadystatechange = function() {
				if (this.readyState == 4 && this.status == 200) {

					var container = document.createElement('div');

					container.innerHTML = this.responseText;
					contentHolder.append(container);

					var modal = new BSN.Modal(document.getElementById(target));
					modal.show();
				}
			};

			xhr.open('GET', 'https://' + avastGlobals.web.domain + '/' + avastGlobals.web.locale + '/' + target, true);
			xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');
			xhr.send(null);
		} else {
			var modal = new BSN.Modal(document.getElementById(target));
			modal.show();
		}
	}

	$open.on('click', function() {
		var $target = $(this).parents('section').find('.js-features-content');

		$target.addClass('show');
		$(this).addClass('d-none');
	});

	$close.on('click', function() {
		var $target = $(this).parents('.js-features-content'),
			$openButton = $target.parents('section').find('.js-open');

		$openButton.removeClass('d-none');
		$target.removeClass('show');
	});

	$openComparison.on('click', function() {
		var $target = $(this).parent().next('.js-comparison-content');

		$target.addClass('show');
		$(this).addClass('d-none');
	});

	$closeComparison.on('click', function() {
		var $target = $(this).parents('.js-comparison-content'),
			$openButton = $target.prev().find('.js-open-comparison');

		$openButton.removeClass('d-none');
		$target.removeClass('show');

		$('.sticky-bar').removeClass('hidden');

		window.scrollTo({
			top: $openButton.offset().top - window.innerHeight / 2,
			left: 0,
			behavior: 'smooth'
		});
	});

	$(window).on('scroll', function() {
		var scrolledTop = window.pageYOffset;
		var stickyBar = $('.sticky-bar');
		var comarisonTable = $('.js-comparison-content.show');
		if (!comarisonTable.length) {
			return;
		}
		if (scrolledTop > comarisonTable.offset().top && scrolledTop < comarisonTable.offset().top + comarisonTable.outerHeight()) {
			stickyBar.addClass('hidden');
		} else {
			stickyBar.removeClass('hidden');
		}
	});

	// get current js-${platform} class
	function getCurrentPlatform() {
		var jsClasses = {
			'js-pc': 'pc',
			'js-mac': 'mac',
			'js-android': 'android',
			'js-ios': 'ios'
		};
		for (var key in jsClasses) {
			if (jsClasses.hasOwnProperty(key)) {
				if ($('html').hasClass(key)) {
					return jsClasses[key];
				}
			}
		}
		return 'pc';
	}

	function getCurrentPageName() {
		var pathnameSplitted = window.location.pathname.split('/');
		return pathnameSplitted[pathnameSplitted.length - 1];
	}

	// custom button attributes
	var stickyButtons = $('.sticky-bar .btn');
	var stickyBadges = $('.sticky-bar .image-button').parent('.bi-download-link');
	var heroButtons = $('.hero .btn');
	var heroBadges = $('.hero .image-button').parent('.bi-download-link');
	var planButtons = $('#section-table .a1-card .btn, #section-table .tables .btn');
	var planBadges = $('#section-table .a1-card .image-button, #section-table .tables .image-button').parent('.bi-download-link');
	var footerButtons = $('.bft .btn');
	var footerBadges = $('.bft .image-button').parent('.bi-download-link');

	addPositionAttr('sticky', stickyButtons);
	addPositionAttr('sticky', stickyBadges);
	addPositionAttr('hero', heroButtons);
	addPositionAttr('hero', heroBadges);
	addPositionAttr('plans', planButtons);
	addPositionAttr('plans', planBadges);
	addPositionAttr('footer', footerButtons);
	addPositionAttr('footer', footerBadges);

	function addPositionAttr(position, ctas) {
		if (typeof position === 'string' && (ctas && ctas.length)) {
			ctas.attr('data-position', position);
		}
	}
})();
